import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import client, { apiError } from '../api/client';

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [info, setInfo] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/forgot-password', { email });
      setInfo(data.message);
      setTimeout(() => navigate(`/reset?email=${encodeURIComponent(email)}`), 900);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Reset your password</h1>
        <p className="muted small">We'll email you a code to set a new password.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        {info && <div className="alert alert-ok" style={{ marginBottom: 14 }}>{info}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Send reset code'}
          </button>
        </form>
        <p className="small center" style={{ marginTop: 16 }}>
          <Link to="/login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
